import React from 'react';
import ResponsiveImage from 'components/elements/common/ResponsiveImage/ResponsiveImage';

const Lede = ({ lede, images }) => {
  if (!lede) {
    return null;
  }

  const ledeImage = images.find(({ id }) => id === lede.id);
  if (!ledeImage) {
    return null;
  }

  const { watermark, title } = ledeImage;
  const crops = {
    desktop: '814x541',
    tablet: '768x510',
    mobile: '320x213',
  };

  return (
    <ResponsiveImage className="news--lede" imageUrl={watermark} crops={crops} title={title} />
  );
};

export default Lede;
